
  import search from "@/mixins/search";
  import gtag from "@/mixins/gtag";

  export default {
    name: "PropertiesIndex",
    mixins: [
      search,
      gtag,
    ],
    middleware: [
      'load-page-blocks'
    ],
    data() {
      return {
        newLat: null,
        newLon: null,
        markerHoverId: null,
        propertyHoverId: null,
        allFilters: false,
        isShowMap: false,
      }
    },
    head() {
      return {
        title: this.network?.name ? `${this.network.name} - ${this.$t('main.words.book_now')}` : this.$t('main.words.book_now'),
        meta: [
          { hid: 'og:title', name: 'og:title', content: this.network?.name ? `${this.network.name} - ${this.$t('main.words.book_now')}` : this.$t('main.words.book_now') },
          { hid: 'og:description', name: 'og:description', content: `${this.network.name}: ${this.properties.map(a => a.name).join(', ')}`
        },
          { hid: 'description', name: 'description', content: `${this.network.name}: ${this.properties.map(a => a.name).join(', ')}`
          },
          {
            hid: 'og:image',
            name: 'og:image',
            content: this.network.images?.length ? this.network.images[0]?.sizes_full_path.high : 'https://source.unsplash.com/random/800%C3%97800/?travel' ,
          }
        ],
      }
  },
    created() {
      if (this.network && this.network.default_search === this.$const('default_search', 'GRID_MAP')) {
        this.isShowMap = true;
      }
    },
    mounted() {
      this.submitSearch({
        data: true,
        redirect: 'properties'
      });
    },
    methods: {
      paginate(page) {
        this.initFilters();
        this.submitSearch({
          page: page,
          data: true,
          redirect: 'properties'
        });
      },
      hoverProperty(property) {
        if (property.latitude && property.longitude) {
          this.newLat = property.latitude;
          this.newLon = property.longitude;
          this.markerHoverId = property.id;
        }
      },
    },
    computed: {
      isNoResults() {
        return (
          !this.properties ||
          !this.properties.length ||
          this.isSuggestion
        ) && !!this.searchFilters.start_date;
      }
    }
  };
